var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/public-layout/components/sonar.tsx";
import React from 'react';

const Sonar = () => /*#__PURE__*/React.createElement("div", {
  className: "relative",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 4,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "relative w-48 h-48",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 5,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "animate-sonar-scale-4 absolute top-0 left-0 w-full h-full rounded-full bg-primary-600/25 dark:bg-primary-600/25 opacity-0 pointer-events-none",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 6,
    columnNumber: 7
  }
}), /*#__PURE__*/React.createElement("div", {
  className: "animate-sonar-scale-3 absolute top-0 left-0 w-full h-full rounded-full bg-primary-600/25 dark:bg-primary-600/25 opacity-0 pointer-events-none",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 7,
    columnNumber: 7
  }
}), /*#__PURE__*/React.createElement("div", {
  className: "animate-sonar-scale-2 absolute top-0 left-0 w-full h-full rounded-full bg-primary-600/25 dark:bg-primary-600/25 opacity-0 pointer-events-none",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8,
    columnNumber: 7
  }
}), /*#__PURE__*/React.createElement("div", {
  className: "animate-sonar-scale-1 absolute top-0 left-0 w-full h-full rounded-full bg-primary-600/25 dark:bg-primary-600/25 opacity-0 pointer-events-none",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 7
  }
}), /*#__PURE__*/React.createElement("div", {
  className: "absolute top-0 left-0 w-48 h-48 bg-white dark:bg-primary-900 rounded-full",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 7
  }
})));

export default Sonar;